import React from 'react';
import AssignmentList from '../components/AssignmentList';

const AssignmentsPage = () => {
  return (
    <div style={{ padding: 16 }}>
      <AssignmentList />
    </div>
  );
};

export default AssignmentsPage;
